import React, { useState } from 'react';
import Checkbox from 'components/Inputs/Checkbox';
import { Row, Col } from 'react-bootstrap';
import ArraysUtils from 'utils/arrays';

const OPTIONS = [
  { key: 'xls', value: '.XLXS' },
  { key: 'pdf', value: 'PDF' },
];

type FileTypesType = {
  onSelection: (id: string) => void;
};

const FileTypes: React.FC<FileTypesType> = ({ onSelection }) => {
  const [selected, setSelected] = useState<Array<string>>([]);

  const onChange = (id: string) => {
    setSelected(ArraysUtils.addOrRemove(id, selected));
    onSelection(id);
  };

  return (
    <Row className="email-container mt-5">
      <Col lg={12} md={12}>
        <div className="title">File Types</div>
      </Col>
      <Col>
        {OPTIONS.map((option) => (
          <div style={{ marginTop: '0.5rem' }} key={option.key}>
            <Checkbox
              checked={selected.some((v) => option.key === v)}
              label={option.value}
              id={option.key}
              onChange={onChange}
            />
          </div>
        ))}
      </Col>
    </Row>
  );
};

export default FileTypes;
